import script from "./ProjectNotifications.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectNotifications.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectNotifications.vue?vue&type=style&index=0&id=3b5d311a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b5d311a"]])

export default __exports__